/* RESPONSIBLE TEAM: team-frontend-tech */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import safeWindowOpen from 'embercom/lib/safe-window-open';

let openCenteredWindow = function (url: string, height?: number, width?: number, name?: string) {
  let outerWidth = function () {
    return window.outerWidth;
  };

  let outerHeight = function () {
    return window.outerHeight;
  };

  let screenX = function () {
    return window.screenX || window.screenLeft || 0;
  };

  let screenY = function () {
    return window.screenY || window.screenTop || 0;
  };

  name = name || 'Authorize';
  let windowWidth = width || 600;
  let windowHeight = height || 800;
  let windowLeft = outerWidth() / 2 + screenX() - windowWidth / 2;
  let windowTop = outerHeight() / 2 + screenY() - windowHeight / 2;
  windowTop = Math.max(0, windowTop);
  let options = `menubar, width=${windowWidth}, height=${windowHeight}, top=${windowTop}, left=${windowLeft}`;
  return safeWindowOpen(url, name, options);
};

export default openCenteredWindow;
